var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_c('div',[_c('i',[_vm._v(_vm._s(_vm.music))])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }